<template>
  <el-dialog
    v-model="visible"
    title="修改密码"
    width="400px"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="原密码" prop="oldPassword">
        <el-input
          v-model="form.oldPassword"
          type="password"
          show-password
          placeholder="请输入原密码"
        />
      </el-form-item>
      
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="form.newPassword"
          type="password"
          show-password
          placeholder="请输入新密码"
        />
      </el-form-item>
      
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          v-model="form.confirmPassword"
          type="password"
          show-password
          placeholder="请再次输入新密码"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认修改</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import request from '@/api/request'
import authState from '@/utils/authState'
import { useRouter } from 'vue-router'

const visible = ref(false)
const formRef = ref()
const router = useRouter()

const form = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
})

// 验证两次密码是否一致
const validateConfirmPassword = (rule: any, value: string, callback: any) => {
  if (value !== form.value.newPassword) {
    callback(new Error('两次输入的密码不一致'))
  } else {
    callback()
  }
}

const rules = {
  oldPassword: [
    { required: true, message: '请输入原密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
  ],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    { validator: validateConfirmPassword, trigger: 'blur' }
  ]
}

const handleSubmit = async () => {
  if (!formRef.value) return
  
  try {
    await formRef.value.validate()
    
    try {
      // 使用request工具发送请求
      await request.put('/admin/change-password', {
        oldPassword: form.value.oldPassword,
        newPassword: form.value.newPassword
      })
      
      // 关闭对话框
      visible.value = false
      
      // 重置表单
      form.value = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      
      // 显示成功消息并提示用户重新登录
      ElMessage.success('密码修改成功，请重新登录')
      
      // 延迟执行登出操作，让用户有时间看到成功消息
      setTimeout(() => {
        // 执行登出操作
        authState.logout()
        
        // 重定向到登录页面
        router.push({
          path: '/login',
          query: { redirect: '/admin' } // 管理员修改密码后默认回到管理面板
        })
      }, 1500) // 1.5秒后执行登出
    } catch (error: any) {
      console.error('修改密码失败:', error)
      ElMessage.error(error.response?.data?.message || '修改密码失败')
    }
  } catch (error: any) {
    console.error('表单验证失败:', error)
    ElMessage.error('表单验证失败，请检查输入')
  }
}

// 暴露方法给父组件
defineExpose({
  show: () => {
    visible.value = true
  }
})
</script> 